(function($)
{

    $.fn.msxiautocomplete = function(options)
    {
        // build main options before element iteration
        var opts = $.extend({}, $.fn.msxiautocomplete.defaults, options);

        return this.each(function()
                         {
                             var $this = $(this);
                             // build element specific options
                             var eOpts = $.metadata ? $.extend({}, opts, $this.metadata()) : opts;
                             eOpts = $.fn.dataset ? $.extend({}, eOpts, $this.dataset()) : eOpts;

                             $this.autocomplete(eOpts);
                         });
    };
    //
    // plugin defaults
    //
    $.fn.msxiautocomplete.defaults = {
        "minLength": 3,
        "change": function(event, ui){
            var $autocomplete = $(this);
            var eOpts = $.metadata ? $.extend({}, $autocomplete.metadata()) : {};
            eOpts = $.fn.dataset ? $.extend({}, eOpts, $autocomplete.dataset()) : eOpts;
            if(eOpts['idInput'])
            {
                $('#' + eOpts['idInput']).val(ui.item.id);
            }

        },
        "close": function(){
            var $autocomplete = $(this);
            var eOpts = $.metadata ? $.extend({}, $autocomplete.metadata()) : {};
            eOpts = $.fn.dataset ? $.extend({}, eOpts, $autocomplete.dataset()) : eOpts;
            return !eOpts['dontClose'];

        }
    };
})(jQuery);